import React, { useState } from "react";
import "../assets/styles/Project.scss";
import { projects } from "../constants/constants";

const emphasizeSkills = (description: string, skills: string[]): string => {
  skills.forEach((skill) => {
    // Escape special regex characters in the skill
    const escapedSkill = skill.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedSkill})`, "gi");
    description = description.replace(regex, "<strong>$1</strong>");
  });
  return description;
};

const Project: React.FC = () => {
  const [activeImageIndex, setActiveImageIndex] = useState<{ [key: number]: number }>({});

  return (
    <div className="projects-container container" id="projects">
      <div className="skills-container">
        <h1>Projects</h1>
        <div className={`projects-grid ${projects.length === 1 ? "single-project-grid" : ""}`}>
          {projects.map((project) => {
            const currentImgIndex = activeImageIndex[project.id] || 0;
            return (
              <div className={`project ${projects.length === 1 ? "featured-project" : ""}`} key={project.id}>
                <div className="project-media">
                  <a
                    href={project.visit || project.source}
                    target="_blank"
                    rel="noreferrer"
                    className="main-image-link"
                  >
                    <img
                      src={project.images[currentImgIndex]}
                      className="zoom main-preview"
                      alt={`${project.title} screenshot ${currentImgIndex + 1}`}
                      width="100%"
                    />
                  </a>
                  {project.images.length > 1 && (
                    <div className="project-thumbnails">
                      {project.images.map((img, idx) => (
                        <button
                          key={idx}
                          type="button"
                          className={`thumb-btn ${idx === currentImgIndex ? "active" : ""}`}
                          onClick={() =>
                            setActiveImageIndex((prev) => ({ ...prev, [project.id]: idx }))
                          }
                          aria-label={`View screenshot ${idx + 1}`}
                        >
                          <img src={img} alt={`Thumbnail ${idx + 1}`} />
                        </button>
                      ))}
                    </div>
                  )}
                </div>
                <a
                  href={project.visit || project.source}
                  target="_blank"
                  rel="noreferrer"
                >
                  <h2>{project.title}</h2>
                </a>
                <ul>
                  {project.description.map((desc, index) => (
                    <li
                      key={index}
                      dangerouslySetInnerHTML={{
                        __html: emphasizeSkills(desc, project.skills),
                      }}
                    ></li>
                  ))}
                </ul>
                <div className="tags">
                  {project.tags.map((tag, index) => (
                    <span key={index} className="tag">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="skills">
                  <strong>Key Competencies:</strong>
                  {project.skills.map((skill, index) => (
                    <span key={index} className="skill">
                      {skill}
                    </span>
                  ))}
                </div>
                <div className="links">
                  {project.source && (
                    <a href={project.source} target="_blank" rel="noreferrer">
                      Source Code
                    </a>
                  )}
                  {project.visit && (
                    <a href={project.visit} target="_blank" rel="noreferrer">
                      Visit Project
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Project;
